<template>
  <div>
    <span v-for="error in errors" :key="error" class="invalid-feedback d-block normal-text">{{ error }}</span>
  </div>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">

.normal-text {
  text-transform: none;
}

</style>
